import React from 'react';
import { motion } from 'framer-motion';

const MarqueeBanner = () => {
  return (
    <div className="bg-fuchsia-600 text-black font-black uppercase tracking-widest text-xs sm:text-sm py-2 overflow-hidden flex whitespace-nowrap">
      <motion.div
        animate={{ x: [0, -1000] }}
        transition={{ repeat: Infinity, ease: 'linear', duration: 20 }}
        className="flex gap-8"
      >
        {[...Array(10)].map((_, i) => (
          <span key={i} className="flex items-center gap-8">
            <span>Drop 001 Live Now</span>
            <span>•</span>
            <span>Limited Stock</span>
            <span>•</span>
          </span>
        ))}
      </motion.div>
    </div>
  );
};

export default MarqueeBanner;